export const resetPasswordPage = () =>
  import("./ResetPasswordPage").then((m) => ({ Component: m.ResetPasswordPage }));
